


const swiper1 = new Swiper('.swiper-container-1', {
  breakpoints: {
          "@0.00": {
           slidesPerGroup: 2,
  slidesPerView: 2,
            spaceBetween: 5,
            autoplay:false,
          },
          "@0.75": {
           slidesPerGroup: 3,
  slidesPerView: 4,
            spaceBetween: 20,
                 autoplay:true,
          },
          "@1.00": {
         slidesPerGroup: 4,	
  slidesPerView: 4,	
             autoplay:true,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 30,
             autoplay:true,
          },
        },
slidesPerGroup: 4,	
  slidesPerView: 4,	
  autoplay: {	
   delay: 5000,	
 },	
  grid: {	
    rows: 4,	
    fill: 'row',	
  },	
    spaceBetween: 30,	
  	
  // If we need pagination	
  pagination: {	
          el: ".swiper-pagination-1",	
          clickable: true,	
          renderBullet: function (index, className) {	
            return '<span class="' + className + '">' + (index + 1) + "</span>";	
          },	
        },	
   runCallbacksOnInit: true,	
  	
});	
const swiper2 = new Swiper('.swiper-container-2', {
  breakpoints: {
          "@0.00": {
           slidesPerGroup: 2,
  slidesPerView: 2,
            spaceBetween: 5,
            autoplay:false,
          },
          "@0.75": {
           slidesPerGroup: 3,
  slidesPerView: 4,
            spaceBetween: 20,
                 autoplay:true,
          },
          "@1.00": {
         slidesPerGroup: 4,	
  slidesPerView: 4,	
             autoplay:true,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 30,
             autoplay:true,
          },
        },
slidesPerGroup: 4,	
  slidesPerView: 4,	
  autoplay: {	
   delay: 5000,	
 },	
  grid: {	
    rows:4,	
    fill: 'row',	
  },	
    spaceBetween: 30,	
  	
  // If we need pagination	
  pagination: {	
          el: ".swiper-pagination-2",	
          clickable: true,	
          renderBullet: function (index, className) {	
            return '<span class="' + className + '">' + (index + 1) + "</span>";	
          },	
        },	
   runCallbacksOnInit: true,	
  	
});	
